import React, { memo } from 'react'
import { faCoin } from '@fortawesome/pro-duotone-svg-icons'

import ReceivePoints from '../common/ReceivePoints'
import AnimateRewards from '../../shared/animateRewards/AnimateRewards'

const PurchasedPointsSuccess = ({ t, name, ...restProps }) => (
  <ReceivePoints
    title={t('common.congratulations')}
    description={t('buy-points.you-have-successfully-purchased', {
      tokenName: name
    })}
    cancelLabel='common.close'
    submitLabel={t('buy-points.view-balance')}
    t={t}
    icon={faCoin}
    name={name}
    {...restProps}
  >
    <AnimateRewards />
  </ReceivePoints>
)

export default memo(PurchasedPointsSuccess)
